import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "imageContainer" };
const _hoisted_2 = { class: "textContainer" };
const _hoisted_3 = { class: "anchor-bottom" };
import { useRouter } from 'vue-router';
import HeaderBlock from './elements/HeaderBlock.vue';
import MGButton from './elements/MGButton.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'TrackYourSpendPage',
    setup(__props) {
        const router = useRouter();
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", null, [
                _createVNode(HeaderBlock, {
                    title: "Track your spend",
                    transparent: true
                }),
                _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                        _cache[1] || (_cache[1] = _createElementVNode("h2", { class: "title" }, "Make every penny count", -1)),
                        _cache[2] || (_cache[2] = _createElementVNode("p", { class: "paragraph" }, " We'll help you keep track of your spend so you always know how much is left to use - and when it's time to top up. ", -1)),
                        _createElementVNode("div", _hoisted_3, [
                            _createVNode(MGButton, {
                                text: "Close",
                                onClick: _cache[0] || (_cache[0] = ($event) => (_unref(router).go(-1)))
                            })
                        ])
                    ])
                ])
            ]));
        };
    }
});
